import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import style from './DashboardPanelAdd.less'

class DashboardPanelAdd extends Component {
    static propTypes = {
    }

    render() {
        const {onClick} = this.props

        return (
            <div
                className={cx(style.default, {[style.clickable]: onClick})}
                onClick={onClick}>
                <div className={style.add}>+</div>
            </div>
        )
    }
}

export default DashboardPanelAdd


// WEBPACK FOOTER //
// ./lib/core/components/DashboardPanelAdd.js